<template>
  <a-modal :closable="false" :confirm-loading="modalLoading" :footer="null" :maskClosable="false"
           :visible="enabled" title="Ustawianie hasła">
    <p>Aby kontynuować, należy ustawić hasło do swojego konta. Zapamiętaj je dokładnie, ponieważ resetowanie wymaga
      skontaktowania się <span class="no-orphan">z administracją</span>.</p>
    <a-input-password v-model="form.password" :visibilityToggle="true" placeholder="Nowe hasło" style="margin-top: 8px;"
                      type="password" @change="verifyNewPassword()">
      <a-icon slot="prefix" style="color: rgba(0,0,0,.25)" type="lock"/>
    </a-input-password>
    <small :style="'color: red; ' + (formErrors.password.lengthZero ? 'opacity: 1' : 'opacity: 0')">Podane
      hasło
      nie może być puste.</small>
    <a-input-password v-model="form.passwordRepeat" :visibilityToggle="true" placeholder="Powtórz nowe hasło"
                      style="margin-top: 8px; margin-bottom: 8px;" type="password" @change="verifyPasswordRepeat()">
      <a-icon slot="prefix" style="color: rgba(0,0,0,.25)" type="lock"/>
    </a-input-password>
    <small :style="'color: red; ' + (formErrors.passwordRepeat ? 'opacity: 1' : 'opacity: 0')">Podane
      hasła muszą być identyczne.</small>
    <div>
      <strong style="display: block;">Wymagania:</strong>
      <small style="display: block;">
        <a-badge :status="formErrors.password.length ? 'success' : 'default'"/>
        Minimalnie 8
        znaków</small>
      <small style="display: block;">
        <a-badge :status="formErrors.password.uppercase ? 'success' : 'default'"/>
        Minimum jedna duża
        litera</small>
      <small style="display: block;">
        <a-badge :status="formErrors.password.lowercase ? 'success' : 'default'"/>
        Minimum jedna mała
        litera</small>
      <small style="display: block;">
        <a-badge :status="formErrors.password.digit ? 'success' : 'default'"/>
        Minimum
        jedna
        cyfra</small>
      <small style="display: block;">
        <a-badge :status="formErrors.password.special ? 'success' : 'default'"/>
        Minimum
        jeden znak
        specjalny</small>
    </div>
    <div style="text-align: right;">
      <a-button :disabled="!computedCanSubmit" type="primary" @click="handlePasswordChange">Ustaw hasło</a-button>
    </div>
  </a-modal>
</template>

<script>
import httpClient from '../../utils/httpClient';

export default {
  name: "SetPassword",
  props: {
    enabled: Boolean
  },
  data() {
    return {
      modalLoading: false,
      form: {
        password: "",
        passwordRepeat: ""
      },
      formErrors: {
        password: {
          lengthZero: false,
          length: false,
          uppercase: false,
          lowercase: false,
          digit: false,
          special: false
        },
        passwordRepeat: false
      }
    };
  },
  computed: {
    computedCanSubmit: function () {
      return !this.formErrors.password.lengthZero &&
          this.formErrors.password.length &&
          this.formErrors.password.uppercase &&
          this.formErrors.password.lowercase &&
          this.formErrors.password.digit &&
          this.formErrors.password.special &&
          this.form.password === this.form.passwordRepeat
    },
  },
  methods: {
    handlePasswordChange() {
      this.modalLoading = true
      httpClient.post("/identity/password/set", this.form).then((response) => {
        console.log(response)
        this.$message.success("Hasło zostało ustawione")
        this.closeModal()
      }).catch((error) => {
        console.log("ERROR", error.response)
        let message = error.message
        if (error && error.status == 400) {
          if (message.startsWith("The password should contain")) {
            this.$message.warning("Hasło nie spełnia wymagań")
          }
          if (message.startsWith("The passwords provided are")) {
            this.$message.warning("Hasła nie są identyczne")
          }
        } else if (error && error.status == 401) {
          this.$message.error("Twoja sesja wygasła, zaloguj się ponownie")
          this.$router.push("/account/login")
        }
      }).finally(() => {
        this.modalLoading = false
      })
    },
    verifyNewPassword() {
      this.formErrors.password.lengthZero = this.form.password.length === 0
      this.formErrors.password.length = this.form.password.length >= 8

      var digitRegex = /\d/;
      this.formErrors.password.digit = digitRegex.test(this.form.password)

      var uppercaseRegex = /[A-Z]/;
      this.formErrors.password.uppercase = uppercaseRegex.test(this.form.password)

      var lowercaseRegex = /[a-z]/;
      this.formErrors.password.lowercase = lowercaseRegex.test(this.form.password)

      var specialCharRegex = /[^A-Za-z0-9]/;
      this.formErrors.password.special = specialCharRegex.test(this.form.password)
    },
    verifyPasswordRepeat() {
      this.formErrors.passwordRepeat = this.form.passwordRepeat.length > 0 && this.form.password !== this.form.passwordRepeat
    },
    closeModal() {
      this.form = {
        password: "",
        passwordRepeat: ""
      }
      this.formErrors = {
        password: {
          lengthZero: false,
          length: false,
          uppercase: false,
          lowercase: false,
          digit: false,
          special: false
        },
        passwordRepeat: false
      }
      this.$emit("close")
    }
  }
}
</script>